import { SearchIndex } from '../types/SearchIndex';

export const createSearchSortByItemValue = (
  indexName: SearchIndex,
  attributeName?: string,
  decending?: boolean,
): string => {
  if (!attributeName) {
    return `${indexName}`;
  }
  return `${indexName}/sort/${attributeName}:${decending ? 'desc' : 'asc'}`;
};
